import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var AdsEventsMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation SendAdsEvents($input: [SendAdsEventsInput!]!) {\n    sendAdsEvents(input: $input) {\n      status\n    }\n  }\n"])));
export default AdsEventsMutation;